/**
 * Login/Logout Controller
 *
 * 
 */

// the constructor for this object
function LoginLogoutController() { }

// the object
LoginLogoutController.prototype = {
    constructor: LoginLogoutController,
    
    // initialize the controller
    init: function() 
    {
        PortalHelper.debugMessage('Login/Logout Controller Initialized');
    },
    
    // run the controller
    run: function()
    {
        // register the events used by this controller
        this._registerEvents();
        
        // Populate the users name
        this._populateUserName();
        
        // unset all of the stored user data
        this._logout();
            
        // send the user back to the login page
        this._redirectToLogin();
        
        PortalHelper.debugMessage('Login/Logout Controller Ran');
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
        
    },
    
    // populate the user name into the header
    _populateUserName: function()
    {
        var user = PortalMain.PortalUser.getUser();
        
        $('#user-name').html(user.first_nm);
    },
    
    // clear all the user stored data
    _logout: function()
    {
        PortalMain.PortalLogin.logout();
    },
    
    // return the user to the login page
    _redirectToLogin: function()
    {
        setTimeout(function () {
            window.location.href = PortalConfig.portalUrl + '/login/';
        }, 3000);  
    },
}